// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'es6-promise/auto';
import 'isomorphic-fetch';

import 'reflect-metadata';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import 'devexpress-diagram/dist/dx-diagram.min.css';
import '@/styles/app.scss';
import 'leaflet/dist/leaflet.css';

import Vue from 'vue';
import Fragment from 'vue-fragment';
import { InjectionsProvider } from '@/core/helpers/vue-inversify-decorator';
import store from '@/store';
import {
    CONTRACTS,
    AuthServiceContract,
    StringsServiceContract,
    ConfigServiceContract
} from '@/core/contracts';
import { registerControls } from '@/core/components/controls';
import { registerDnD } from '@/core/components/dnd';
import App from '@/App.vue';
import { buildRouter } from '@/router';
import { setupLog } from '@/log';
import container from '@/container';
import { registerPages } from '@/pages';
import { dxSetup } from '@/core/components/table/dxSetup';
import { setupVueFilters } from '@/core/filters';
import { startupServicesAsync } from './startup';
import { LocalizationPlugin } from './plugins/localization';

registerDnD();
registerControls();
registerPages();
setupVueFilters();
dxSetup();

Vue.use(Fragment.Plugin);
Vue.use(new InjectionsProvider(container));
Vue.use(LocalizationPlugin);
Vue.config.productionTip = false;
setupLog();

/**
 * Application startup.
 */
async function startupAsync(): Promise<void> {
    const config = container.get<ConfigServiceContract>(
        CONTRACTS.ConfigService
    );
    await config.startupAsync();

    const strings = container.get<StringsServiceContract>(
        CONTRACTS.StringsService
    );

    const auth = container.get<AuthServiceContract>(CONTRACTS.AuthService);
    auth.init();

    const vueApp = new Vue({
        router: buildRouter(auth),
        store,
        render: h => h(App)
    });
    vueApp.$mount('#app');

    await strings.setupLocalization(vueApp.$l);
    await auth.startupAsync(startupServicesAsync);
}

startupAsync();
